import { LazyFallback } from 'components/shared/LazyFallback';
import { FC, Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const ScheduledQuotesBlotterRouteLazy = lazyWithRetry(() => import('./ScheduledQuotesBlotter'));
export const ScheduledQuotesBlotterRoute: FC = () => (
  <Suspense fallback={<LazyFallback />}>
    <ScheduledQuotesBlotterRouteLazy />
  </Suspense>
);
